export const LANGUAGES = {
	'fr' : 'French',
	'en' : 'English',
	'de' : 'German',
	'es' : 'Spanish',
};


// WEBPACK FOOTER //
// ./client/app/shared/locales/locales.js